/* eslint-disable max-len */
export class ShopProfilePicture {
  code = '';
  downloadUrl = '';
  mime = '';
  url = '';

  constructor(pic = null) {
    if (pic) {
      this.code = pic.code || '';
      this.downloadUrl = pic.downloadUrl || '';
      this.mime = pic.mime || '';
      this.url = pic.url || '';
    }
  }

}
